import { HashLink as Link } from "react-router-hash-link/dist/react-router-hash-link.cjs.production";

import pic from '../Asset/arbaz.jpg'
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import { useRef } from "react";
gsap.registerPlugin(useGSAP, ScrollTrigger);



const Landingpage = () => {
  const main = useRef();
  




  useGSAP(() => {

    gsap.fromTo("#hi", { x: 70, duration: 4, delay: 4  ,opacity:0  }, { x: 0,  duration: 4, ease: "ease.in" ,opacity:1 ,repeat: -1 ,repeatDelay: 4 ,zoom:1 });
    gsap.fromTo("#heading", { y: 50,  }, { y: 0, duration: 2,  delay: 1   });
    gsap.fromTo("#image", { x: 10, opacity: 0 ,rotate:75 ,delay:1.5 ,duration:2 ,zoom:0.5, },
    

    
     { x: 0, opacity: 1, duration: 2.5, ease: "ease.in", delay: 1.5,rotate:5 ,zoom:1, ScrollTrigger: { trigger: "#image" , x:70} });
  },{scope:main})
  return (
    <>
      <div  ref={main}

        id="Landing"
        className=" flex flex-col-reverse   justify-items-center items-center justify-center md:flex-row w-full  lg:p-0  lg:mt-0 h-screen  mt-20  font-sans-serif  "
      >
        <div className="flex flex-col justify-center  m md:mt-0 lg:mt-0  antialiased text-left  w-full p-2  md:w-1/2">

   
          <p className="italic  w-1/2 font-bold text-yellow-900  underline  text-2xl font-Pacifico animate-pulse tracking-wide" id="hi">
            HI,I am
          </p>
          <h1 className="text-4xl tracking-wide font-extrabold text-gray-950  mt-4 lg:mt-6   transition duration-1000 md:text-7xl bg-clip-text text-transparent bg-gradient-to-r from-pink-500 to-violet-500 font-serif animate-typing overflow-hidden whitespace-nowrap" id="heading">
            Arbaz Shaikh
          </h1>
          <p className="inline  mt-2   tracking-wide font-roboto  text-start lg:text-justify   ">
          Hi, I am a <span className="hover:bg-yellow-500 hover:tracking-widest hover:cursor-text">Full Stack Web Developer</span>.An Open Source enthusiast and a Computer Science graduate from India. 
            With different programming
            languages and frameworks, I produce user-friendly web applications
            that are functionally designed.My commitment to innovation ensures
            that I provide latest solutions that go beyond the client’s
            expectations.
          </p>
          <p className="inline  mt-2 p-2   tracking-wide font-sans  text-start lg:text-justify   ">
          I love working on new and exciting technologies. I have a keen interest in Web Development and I am always looking for new opportunities to learn and grow.
          </p>
          <button className="  md:w-1/2 text-white px-4 py-2 rounded-full mt-12 w-3/2 text-2xl transition ease-in-out delay-100 bg-blue-500   hover:bg-indigo-500 duration-300 ...  hover:cursor-pointer font-mono ">
            <Link to="#contact">Get in Touch</Link>
          </button>
          
        </div>
        <div className="     p-4 h-96 w-96 border-1 lg:bottom-  border-yellow-500 shadow-2xl lg:border-2  border-dashed  " id="image">
          <img className="h-86 w-96              shadow-yellow-300 shadow-inner 
           " src={pic} alt="arbaz" />
     
        </div>
        
     
      
      </div>


    </> 
  );
};
export default Landingpage;
